<script lang="ts">
    import { onDestroy } from "svelte";
    import { get } from "svelte/store";
    import { WSSFront, wssStatus } from "../wsfront";
    import { currentTest, messageInfo } from "../store";
    import type { Todo } from "../../../shared/wspayload";
    import Animate from "../components/Animate.svelte";

    /*
    Note :
    We stay on test page until websocket is disconnected
    Backend is responsible to stop connection on various case (success, fail, timeout...)
    onDestroy may abort connection (if user request history back)
    */

    let input: HTMLButtonElement;
    let test: Todo = null;
    let info = get(messageInfo);
    let remain = 60;
    let deadline = Date.now() + remain * 1000;

    let interval = setInterval(() => {
        remain = Math.round((deadline - Date.now()) / 1000);
        if (remain <= 0) remain = 0;
    }, 1000);

    currentTest.set(test);

    const wssFront = new WSSFront(onStatus, onTest);

    function onStatus(status: wssStatus) {
        if (status == wssStatus.ready) wssFront.send(info);
        else if (input) input.click();
    }

    function onTest(value: Todo) {
        test = value;
        deadline = new Date(value.deadline).getTime();
        currentTest.set(test);
    }

    onDestroy(() => {
        input = null;
        wssFront.close();
        clearInterval(interval);
    });
</script>

<main>
    {#if test != null}
        <div class="spinner-border text-danger big mt-5" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <div class="counter">{remain}</div>

        <!-- Key is used to respawn animate when test change -->
        <div class="text">
            {#key deadline}
                <Animate>
                    {test.guidelines}
                </Animate>
            {/key}
        </div>
    {/if}

    <!-- Hidden Button to submit the form without having reference on -->
    <button bind:this={input} type="submit" style="display: none;" />
</main>

<style>
    main {
        text-align: center;
    }

    .counter {
        position: relative;
        color: red;
        margin-top: -64px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        font-weight: bold;
    }

    .text {
        padding: 150px 0px;
    }

    .big {
        width: 60px;
        height: 60px;
    }
</style>
